import { lazy } from 'react';
const BulkCollection = lazy(() => import('./BulkCollection'));

const BulkCollectionRoutes = [
  {
    path: '/bulkcollection',
    component: BulkCollection
  }
];

export default BulkCollectionRoutes;
